// extracted by mini-css-extract-plugin
export default {"logos":"Footer_logos__6RC-8"};